<div class="input time">
  <input
    #timeInput
    type="text"
    class="input-control"
    placeHolderCharacter=" "
    [ngStyle]="config()?.inputStyles"
    [formControl]="displayedTimeFormControl"
    (keydown)="timeInputKeyDown($event)"
    (click)="openTimePicker()"
    (focus)="selectTimeInput()"
    (beforeinput)="timeInputTransform($event, displayedTimeFormControl)"
    (paste)="timeInputPaste($event, displayedTimeFormControl)"
    (blur)="timeInputBlur($event, displayedTimeFormControl)"
  />
  <div #menuTrigger [matMenuTriggerFor]="menu"></div>
  <mat-menu
    #menu
    class="bd-menu inline-editor-time-picker with-theme"
    [hasBackdrop]="false"
    [xPosition]="'before'"
  >
    <ng-template matMenuContent>
      @let timeProposalArray = (timeProposalArray$ | async) ?? [];
      <blaze-scroller>
        @for (timeProposal of timeProposalArray; track timeProposal) {
          <button
            class="min-w-[90px]"
            [class.selected]="displayedTimeFormControl.value === timeProposal"
            mat-menu-item
            [value]="timeProposal"
            (click)="patchTimeProposal(timeProposal); closeTimePicker()"
          >
            {{ timeProposal }}
          </button>
        }
        @if (!timeProposalArray.length) {
          @for (timeProposal of proposedValuesFromInput; track timeProposal) {
            <button
              mat-menu-item
              class="min-w-[90px]"
              (click)="patchTimeProposal(timeProposal); closeTimePicker()"
            >
              {{ timeProposal }}
            </button>
          }
        }
      </blaze-scroller>
    </ng-template>
  </mat-menu>
</div>
